// NewTaskLoginPopup — shows a prominent pop-up right after login when the
// logged-in user has newly assigned (unread) tasks. Appears once per login.

import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { X, ClipboardList } from "lucide-react";
import axios from "axios";
import "../css/tasks/taskdetail.css";

// Uses the same notifications API as the bell
const API = "https://apicrm.zenrealestate.in/api/notifications";

export default function NewTaskLoginPopup() {
  const [tasks, setTasks] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    // Only show once per login (a new login issues a new token)
    if (sessionStorage.getItem("newTaskAlertToken") === token) return;

    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(API, {
          headers: { Authorization: "Bearer " + token },
        });
        const data = res.data.data || [];
        const fresh = data.filter((n) => n.type === "task_assigned" && !n.read);
        if (!cancelled && fresh.length) {
          setTasks(fresh);
          setOpen(true);
        }
      } catch (e) {
        /* ignore (e.g. no token / network) */
      }
      sessionStorage.setItem("newTaskAlertToken", token);
    })();

    return () => { cancelled = true; };
  }, []);

  if (!open) return null;

  const plural = tasks.length > 1;

  return createPortal(
    <div className="td-overlay" onClick={() => setOpen(false)}>
      <div className="td-modal td-modal-sm" onClick={(e) => e.stopPropagation()}>
        <div className="td-header">
          <h3 className="td-title">
            <ClipboardList size={18} style={{ marginRight: 6, verticalAlign: "-3px", color: "#2563eb" }} />
            New Task{plural ? "s" : ""} Assigned
          </h3>
          <button className="td-close" type="button" onClick={() => setOpen(false)}>
            <X size={18} />
          </button>
        </div>

        <div className="td-body">
          <p className="td-desc" style={{ marginBottom: 12 }}>
            You have <strong>{tasks.length}</strong> new task{plural ? "s" : ""} assigned to you.
          </p>

          <ul className="ntp-list">
            {tasks.slice(0, 5).map((n) => (
              <li key={n._id} className="ntp-item">{n.message || n.title}</li>
            ))}
            {tasks.length > 5 && (
              <li className="ntp-item ntp-more">+ {tasks.length - 5} more</li>
            )}
          </ul>

          <div className="tr-actions">
            <button className="tr-btn-cancel" type="button" onClick={() => setOpen(false)}>
              Dismiss
            </button>
            <button
              className="tr-btn-save"
              type="button"
              onClick={() => { setOpen(false); navigate("/tasks"); }}
            >
              View Tasks
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
